import { Autocomplete, AutocompleteItem, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@nextui-org/react";
import { useState } from "react";
import { Language } from "../types/Types";

export type LanguageSelectionProps = {
    selectedLanguage: Language;
    setSelectedLanguage: (value: Language) => void;
}

export const languages: Language[] = [
    {
        name: "English",
        isoCode: "en",
        greetings: [
           "Hi! I hope you are having a great day. What can I help you with?"
        ]
    },
    {
        name: "French",
        isoCode: "fr",
        greetings: [
            "Salut! J'espère que vous passez une excellente journée. Comment puis-je vous aider?"
        ]
    },
    {
        name: "German",
        isoCode: "de",
        greetings: [
            "Hallo! Ich hoffe, du hast einen tollen Tag. Wie kann ich dir helfen?"
        ]
    },
    {
        name: "Italian",
        isoCode: "it",
        greetings: [
            "Ciao! Spero che tu stia passando una bella giornata. Come posso aiutarti?"
        ]
    },
    {
        name: "Hindi",
        isoCode: "hi",
        greetings: [
            "नमस्ते! आशा करता हूँ कि आपका दिन शानदार हो रहा है। मैं आपकी कैसे मदद कर सकता हूँ?"
        ]
    },
    {
        name: "Tamil",
        isoCode: "ta",
        greetings: [
            "வணக்கம்! நீங்கள் நல்ல நாளாக இருக்கிறீர்கள் என்று நம்புகிறேன். நான் எப்படி உதவலாம்?"
        ]
    }
];

export const LanguageSelection: React.FC<LanguageSelectionProps> =
    ({
        selectedLanguage, setSelectedLanguage
    }) => {
        const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
        const [language, setLanguage] = useState(selectedLanguage);
        return (
            <>
                <button className="flex w-fit gap-2 items-center rounded-full border border-gray-300 px-3 py-1 bg-white"
                    onClick={onOpen}>
                    {selectedLanguage.name}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
                        className="size-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                <Modal isOpen={isOpen} onClose={onOpenChange}>
                    <ModalContent>
                        <ModalHeader>Choose your preferred language</ModalHeader>
                        <ModalBody>
                            <Autocomplete aria-label="Select Language" placeholder="Select Language"
                            inputProps={{
                                classNames:{ input: "border-none outline-none focus:ring-0" }
                            }}
                            selectedKey={language.isoCode}
                            onSelectionChange={(key) => {
                                const selectedLanguage = languages.find((language) => language.isoCode === key);
                                if (selectedLanguage) {
                                    setLanguage(selectedLanguage);
                                }
                            }}>
                                {
                                    languages.map((language) => (
                                        <AutocompleteItem key={language.isoCode} value={language.isoCode}>
                                            {language.name}
                                        </AutocompleteItem>
                                    ))
                                }
                            </Autocomplete>
                            
                        </ModalBody>
                        <ModalFooter>
                            <button className="px-3 py-1 rounded-md border text-base" onClick={onClose}>Cancel</button>
                            <button className="px-3 py-1 bg-black rounded-md text-white text-base" onClick={() => {
                                setSelectedLanguage(language);
                                onClose();
                            }}>Confirm</button>
                            
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </>

        );
    }